// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import cn from 'classnames';

import etask from 'zetask';
import hola_opt from 'hola_opt';
import {App_context} from 'hola_app_context';
import {perr, perr_www_visit} from 'hola_pub_util';
import {get} from 'zutil';

import {Settings_context, use_theme} from '../../../../../hola/pub/settings_ctx';
import {Tab_buttons} from '../../../../../hola/pub/ui/premium/tab_buttons';
import {Checkbox} from '../../../../../hola/pub/lib/checkbox';
import {use_qs} from '../../../../../hola/pub/lib/use_qs';
import Icon_arrow_right from '../../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import Icon_question from '../../../../../hola/pub/img/hola2023/icons/16/question.svg';
import {Gpay_stripe} from '../../payment_methods/gpay_stripe/gpay_stripe';
import {use_screen} from '../../../../../hola/pub/lib/screen_util';
import {toolip_img_url} from '../../../../../hola/pub/ui/toolip_img_url';
import plus_util from '/www/hola/pub/plus_util.js';
// @ts-ignore
import {CC_stripe, CC_bluesnap_hpf} from '/www/hola/pub/plus_ui.js';
import {use_browser} from '../../../../../hola/pub/lib/use_browser';
import {on_toolip_init, t_payment_method} from './api_utils';
import styles from './payment_form.module.less';
import {t_provider} from '../../../types';
import {Paypal_payment} from '../../payment_methods/paypal/paypal_btn';
import {useHistory} from 'react-router-dom';
import {total_orders_count} from '../../dashboard/utils';
import {use_app_context} from '../../../lib/app_context';

type t_purchase_disabled_warning = {
  need_kyc?: boolean,
}
export const Purchase_disabled_warning = ({need_kyc = false}:
  t_purchase_disabled_warning)=>{
  const {theme} = useContext(Settings_context);
  return <div className={styles.warning_container}>
    <div className={styles.warning_content}>
      <p className={cn(theme.p5, theme.color_n700, styles.disabled_warn)}>
        <img src='/www/toolip/pub/img/warning.svg'/>
        {need_kyc ?
          'This transaction has been flagged as suspicious. To proceed ' +
          'with your proxies purchase, please complete our identity ' +
          'verification process below.'
        : 'Hold: Your IP has been flagged as suspicious'}
      </p>
    </div>
  </div>;
};

const btn_props_default = {
  arrow: false,
  no_jump: true,
  round: false,
  size: 'lg',
  cls: styles.buy_button,
  color: 'black',
};

type t_btn_props = Partial<typeof btn_props_default>;

type t_payment_form = {
    plan_id: string;
    method_id?: string;
    purchase_disabled?: boolean;
    usage_charges: boolean;
    show_usage_charges: boolean;
    on_change_usage_charges: (val: boolean)=>void;
    cc_method: t_provider;
    set_cc_method: (p: t_provider)=>void;
    submitting: boolean;
    set_submitting: (v: boolean)=>void;
    refresh_after_cc_payment_success: ()=>void;
    on_payment_done: (res: object, email: string)=>void;
    set_payment_method: (m: string)=>void;
    buy_btn_props?: t_btn_props;
    terms_elem?: JSX.Element;
    title_elem?: JSX.Element;
    cc_title?: JSX.Element;
    p_title?: JSX.Element;
    bundle?: string;
    Button_cmp?: (props: object_of<any>)=>JSX.Element;
    input_style?: object_of<any>;
    gtag_id?: string;
    zone_id?: string;
    group_id?: string;
    is_renew_payment?: boolean;
    migrate_product_id?: string;
    extra_limit?: number;
    methods_allowed?: string[];
    need_kyc?: boolean;
    card_img_src?: string;
    cvv_img_src?: string;
    with_skeleton?: boolean;
};

export const Payment_form = ({plan_id, purchase_disabled = false,
    method_id = 'cc', cc_method, set_cc_method, usage_charges, zone_id,
    is_renew_payment, group_id, migrate_product_id,
    on_change_usage_charges, show_usage_charges, submitting, extra_limit,
    terms_elem, title_elem, cc_title, p_title, buy_btn_props = {},
    bundle = 'toolip', Button_cmp, input_style, gtag_id,
    set_payment_method, set_submitting, on_payment_done,
    refresh_after_cc_payment_success,
    card_img_src, cvv_img_src, with_skeleton,
    methods_allowed = ['cc', 'paypal', 'google', 'apple'],
    need_kyc = false}: t_payment_form)=>{
    const {theme} = use_theme();
    const {dashboard} = use_app_context();
    const {orders} = dashboard.info;
    const btn_props = {...btn_props_default, ...buy_btn_props};
    const {show_popup} = useContext(Settings_context);
    const history = useHistory();
    const browser = use_browser();
    const qs = use_qs();
    const {is_client, user} = useContext(App_context);
    const plan = hola_opt.all_plans.find(p=>p.id==plan_id);
    const plan_config = hola_opt.plans_config[plan_id];
    const [methods, set_methods] = useState(()=>{
        const m = [{id: 'cc', title: cc_title ?? 'Credit Card'}];
        const allowed = new Set(methods_allowed);
        if (hola_opt.www_hola.paypal_in_form && allowed.has('paypal'))
            m.push({id: 'paypal', title: p_title ?? 'Paypal'});
        if (browser == 'chrome' && hola_opt.www_hola.google_pay
            && allowed.has('google'))
        {
            m.push({id: 'google', title: 'Google Pay'});
        }
        if (browser == 'safari' && hola_opt.www_hola.apple_pay
            && allowed.has('apple'))
        {
            m.push({id: 'apple', title: 'Apple Pay'});
        }
        return m;
    });
    const on_no_google_methods = ()=>{
        set_methods(pr=>pr.map(m=>m.id==='google' ? {...m, hide: true} : m));
        set_payment_method('cc');
    };
    const on_no_apple_methods = ()=>{
        set_methods(pr=>pr.map(m=>m.id==='apple' ? {...m, hide: true} : m));
        set_payment_method('cc');
    };
    const on_paypal_error = ()=>{
        set_methods(pr=>pr.map(m=>m.id==='paypal' ? {...m, hide: true} : m));
        set_payment_method('cc');
    };
    const [email, set_email] = useState(user ? get(user, 'emails.0.value')
        : '');
    const on_payment = (res: object)=>{
        on_payment_done(res, email);
    };
    useEffect(()=>{
        if (user && get(user, 'emails.0.value'))
            set_email(get(user, 'emails.0.value'));
    }, [user]);
    useEffect(()=>{
        perr_www_visit({id: 'toolip_pricing_checkout_visit'});
        try {
            (window as any).dataLayer.push({event: 'gtag.checkout_form_view'});
        } catch(e){}
        etask(function*(){
          const current_cc_method:
            t_payment_method = yield on_toolip_init(plan_id);
          set_cc_method(current_cc_method.provider);
          perr({id:
            `toolip_checkout_${current_cc_method.provider}_loaded`});
        });
    }, []);
    const [email_error, set_email_err] = useState('');
    const get_email = ()=>email;
    const on_submit = ()=>{
        perr({id: `toolip_checkout_${
            method_id=='cc' ? cc_method : method_id}_click_submit`,
            info: {email},
        });
    };
    const submit_payment = (type, opt)=>{
        try {
            (window as any).dataLayer.push({
                event: 'gtag.purchase',
                conversionValue: plan.price,
            });
        } catch(e){}
        perr({id: 'www_pro_checkout_submit_payment'});
        opt = Object.assign({}, opt, {
            usage_charges, zone_id, group_id, extra_limit, is_renew_payment,
            proxy_endpoint: !!qs.proxy_endpoint, migrate_product_id,
            before_payment: (provider:string, t:string,
                bp_opt={} as any)=>
            {
                let bp_email = bp_opt.email;
                if (!bp_email && user)
                    bp_email = get(user, 'emails[0].value');
                let is_new_user;
                let fake_user;
                if (!user)
                {
                    is_new_user = true;
                    fake_user = bp_email ? {hola_uid: 'basic/'+bp_email,
                        emails: [{value: bp_email}],
                        provider: 'basic'} : {};
                }
                try {
                    (window as any).dataLayer.push({
                        event: 'gtag.capture_user_email',
                        user_email: bp_email,
                    });
                } catch(e){}
                return {
                    is_new_user,
                    user: user || fake_user,
                    email: bp_email,
                    coupon: bp_opt.coupon,
                    currencies: bp_opt.currencies,
                    vat_obj: bp_opt.vat_obj,
                    cart: bp_opt.cart,
                    plan: bp_opt.plan,
                    bundle: bp_opt.bundle,
                    currency: bp_opt.currency,
                };
            },
            is_new_user: !user,
        });
        return plus_util.payment_api(type, opt);
    };
    const on_payment_success = res=>{
        const gtag_event = !user || total_orders_count(orders) < 1
          ? gtag_id || 'gtag.purchase_success'
          : hola_opt.www_hola.conversions.tags['additional_purchase'];
        try {
            (window as any).dataLayer.push({
                event: gtag_event,
                conversionValue: plan.price,
            });
        } catch(e){}
        if (hola_opt.www_hola.send_purchase_google_ads)
        {
            try {
                (window as any).gtag('event', 'conversion', {
                    send_to: 'AW-16555647232/HYxACNnZxa0ZEIDCrNY9',
                    transaction_id: res.payment_intent_id,
                    value: plan.price,
                    currency: 'usd',
                });
            } catch(e){
                console.error(e);
            }
        }
        if (hola_opt.www_hola.use_pap)
        {
            try {
                // @ts-ignore
                const sale = PostAffTracker.createSale();
                sale.setTotalCost(plan.price);
                sale.setOrderID(res.payment_intent_id);
                sale.setProductID(`${qs.test ? 'test_' : ''}${plan.id}`);
                // @ts-ignore
                PostAffTracker.register();
            } catch(e){
                console.error(e);
            }
        }
        perr({id: `toolip_checkout_${
            method_id=='cc' ? cc_method : method_id
        }_payment_success`, info: {email,
            plan_id: plan.id,
            price: plan.price,
        }});
        perr({id: 'www_toolip_checkout_on_payment'});
    };

    const {width} = use_screen();
    const terms = terms_elem ?? <p className={cn(styles.terms, theme.p4)}>
      By submitting this form, you agree to our <a
        href="/legal/terms-conditions" target="_blank"
        rel="noopener noreferrer">Terms of Service</a> and <a
          href="/legal/privacy-policy" target="_blank"
          rel="noopener noreferrer">Privacy Policy</a>
    </p>;
    const is_cc = method_id == 'cc';
    const on_before_cc_payment = ()=>{
        set_submitting(true);
        perr({id: `toolip_checkout_${
            method_id=='cc' ? cc_method : method_id}_click_submit`,
            info: {email},
        });
    };
    const on_after_cc_payment_success = ()=>{
        set_submitting(false);
        refresh_after_cc_payment_success();
    };
    const on_after_cc_payment_error = ()=>{
        set_submitting(false);
        perr({id: `toolip_checkout_${
            method_id=='cc' ? cc_method : method_id}_payment_error`,
            info: {email},
        });
    };
    const on_err_dlg = zone_id && extra_limit
        ? ()=>{
            let err_page = `/dashboard/page/plans`
                +`?notification=extra_limit_fail&extra_limit=${extra_limit}`
                +`&zone_id=${zone_id}&price=${qs.price}`;
            if (group_id)
                err_page += `&group_id=${group_id}`;
            history.push(err_page);
        } : zone_id ? ()=>{
            const err_page = `/dashboard/page/plans`
                +`?notification=auto_renew_fail&plan_id=${plan_id}`
                +`&zone_id=${zone_id}`;
            history.push(err_page);
        } : undefined;
    const is_gpay = ['apple', 'google'].includes(method_id);

    const package_gb = plan_config.limit.toFixed(2);
    const package_gb_110 = (plan_config.limit * 1.1).toFixed(2);
    const package_gb_10 = (plan_config.limit * 0.1).toFixed(2);
    const total= plan.price;
    const per_gb_cost = (total / plan_config.limit).toFixed(2);
    const per_10_cost = (total * 0.1).toFixed(2);

    return <>
      {title_elem ?? <p className={cn(theme.p18, theme.med, styles.title)}>
        Payment method
      </p>}
      <Tab_buttons items={methods} active={method_id}
        on_change={next_method_id=>set_payment_method?.(next_method_id)}
        sliding class_name={styles.payment_tabs}/>
        {is_client && <>
          <div className={cn(styles.payment_container_gpay,
            !is_gpay && styles.payment_container_gpay_hidden)}>
            {is_gpay && terms}
            <Gpay_stripe
              user={user}
              plan={plan}
              email={email}
              set_email={set_email}
              email_err={email_error}
              set_email_err={set_email_err}
              hidden={method_id != 'google'}
              method_config={hola_opt.stripe.google_pay}
              on_fallback={on_no_google_methods}
              on_after_payment={(res, res_email)=>{
                set_submitting(false);
                on_payment_success(res);
                on_payment_done(res, res_email);
              }}
              on_submit={()=>{
                on_submit();
              }}
              on_before_payment={()=>{
                set_submitting(true);
              }}
              disabled={purchase_disabled}
            />
            <Gpay_stripe
              user={user}
              plan={plan}
              email={email}
              set_email={set_email}
              email_err={email_error}
              set_email_err={set_email_err}
              hidden={method_id != 'apple'}
              method_config={hola_opt.stripe.apple_pay}
              on_fallback={on_no_apple_methods}
              on_after_payment={(res, res_email)=>{
                set_submitting(false);
                on_payment_success(res);
                on_payment_done(res, res_email);
              }}
              on_submit={()=>{
                on_submit();
              }}
              on_before_payment={()=>set_submitting(true)}
              disabled={purchase_disabled}
            />
          </div>
          {hola_opt.www_hola.paypal_in_form && <div>
            <Paypal_payment
              cls={styles.payment_container_paypal}
              submitting={submitting}
              on_after_payment={(res, res_email)=>{
                set_submitting(false);
                on_payment_success(res);
                on_payment_done(res, res_email);
              }}
              on_submit={()=>{
                on_submit();
              }}
              on_before_payment={()=>set_submitting(true)}
              user={user}
              plan={plan}
              currency='USD'
              hidden={method_id != 'paypal'}
              on_fallback={on_paypal_error}
            />
          </div>}
          <div className={cn(styles.payment_container_cc,
            !is_cc && styles.hidden,
            'step-payment--hola2023')}>
          {cc_method == 'stripe' && <CC_stripe api={plus_util.api}
            bundle={bundle}
            show={is_cc} email_in_cc
            plan={plan}
            email={email}
            submit_caption={<Fragment>
              Buy now <Icon_arrow_right />
            </Fragment>}
            get_email={get_email}
            set_email={set_email}
            set_email_err={set_email_err}
            get_hola_uid={()=>user?.hola_uid}
            email_error={email_error}
            submit_payment={submit_payment}
            on_payment={res=>{
              on_payment_success(res);
              on_payment(res);
            }}
            set_fallback_route={bundle === 'toolip' ? ()=>{
              plus_util.api.bluesnap = true;
              plus_util.api.stripe = false;
              perr({id: 'www_stripe_fallback_detected', info: {email}});
              set_cc_method('bluesnap');
            }: false}
            before_payment={on_before_cc_payment}
            after_payment={on_after_cc_payment_success}
            on_submit_err={on_after_cc_payment_error}
            on_err_dlg={on_err_dlg}
            no_checkout_promo
            no_legal
            before_btn_component={terms}
            Button_cmp={Button_cmp}
            btn_props={{...btn_props}}
            user={user}
            Tooltip_card={<Tooltip_card card_img_src={card_img_src} />}
            Tooltip_cvv={<Tooltip_cvv cvv_img_src={cvv_img_src} />}
            cc_label_with_card_icons
            purchase_disabled={purchase_disabled}
            purchase_disabled_warning={<Purchase_disabled_warning
              need_kyc={need_kyc}/>}
            input_style={input_style}
            with_skeleton={with_skeleton}
            />}
          {cc_method == 'bluesnap' && <CC_bluesnap_hpf
            api={plus_util.api}
            bundle={bundle}
            show={is_cc} email_in_cc
            email={email}
            plan={plan}
            submit_caption={<Fragment>
              Buy now <Icon_arrow_right />
            </Fragment>}
            get_email={get_email}
            set_email={set_email}
            set_email_err={set_email_err}
            get_hola_uid={()=>user?.hola_uid}
            email_error={email_error}
            submit_payment={submit_payment}
            on_payment={res=>{
              on_payment_success(res);
              on_payment(res);
            }}
            before_payment={on_before_cc_payment}
            after_payment={on_after_cc_payment_success}
            on_submit_err={on_after_cc_payment_error}
            set_fallback_route={()=>{
              plus_util.api.bluesnap_hpf = false;
              plus_util.api.stripe = true;
              set_cc_method('stripe');
            }}
            no_checkout_promo
            no_legal
            before_btn_component={terms}
            btn_props={{...btn_props}}
            user={user}
            Tooltip_card={<Tooltip_card card_img_src={card_img_src} />}
            Tooltip_cvv={<Tooltip_cvv cvv_img_src={card_img_src} />}
            cc_label_with_card_icons
            purchase_disabled={purchase_disabled}
            purchase_disabled_warning={<Purchase_disabled_warning/>}
          />}
          </div>
        </>}
        {show_usage_charges &&
        <div className={styles.usage_charges_wrapper}>
          <Checkbox
            size="xs" light
            caption="Enable additional usage charges"
            checked={usage_charges}
            on_change={on_change_usage_charges}/>
          <button type="button" className={styles.question_mark} onClick={ev=>{
            const target = (ev.target as HTMLElement).parentElement;
            show_popup('usage_charges_toolip', ()=>{
              return <p className={cn(styles.usage_charges_tooltip,
                theme.p4)}>
                When you enable additional usage charges, you agree to incur
                fees if your usage exceeds the limits of your current plan.
                For instance, if your plan includes {package_gb} GB of data
                per month and you use {package_gb_110} GB, you will be charged
                an extra fee for the additional {package_gb_10} GB of data.
                The overage fee is ${per_gb_cost} per GB
                (total ${per_10_cost}).
                This charge will appear on your next billing cycle.
                To avoid unexpected charges, we recommend monitoring your
                usage regularly and considering an upgrade
                if you consistently exceed your plan's limits.
              </p>;
            },
            {
              strategy: 'bind auto auto auto',
              anchor_element: target,
              offset_top: -220 - 0.25*Math.max(600 - width, 0),
              parent: target,
              get_offset_from_screen: true,
            });
            }}><Icon_question /></button>
        </div>}
    </>;
};

const Tooltip_card = ({card_img_src}: {card_img_src?: string})=>{
  const {theme} = useContext(Settings_context);
  return <div className={styles.example}>
    <p className={theme.p12}>
      This is a 16-digit number on the front of your card</p>
    <div className={styles.image}>
      <img src={card_img_src ?? toolip_img_url('card_ex.png')} width={107}/>
    </div>
  </div>;
};

const Tooltip_cvv = ({cvv_img_src}: {cvv_img_src?: string})=>{
  const {theme} = useContext(Settings_context);
  return <div className={styles.example}>
    <p className={theme.p12}>
      This is a 3 digit number on your VISA, MasterCard
      or Discovery, or a 4 digit number on your American Express.
    </p>
    <div className={cn(styles.image, styles.w185)}>
      <img src={cvv_img_src ?? toolip_img_url('cvv_ex.png')} width={185}/>
    </div>
  </div>;
};
